import { XIcon } from "icons/outline";

export const AccountChip = ({
  account: [id, name],
  onDeleteAccount,
}: {
  account: [string, string];
  onDeleteAccount?: (id: string) => void;
}) => {
  return (
    <div className="flex items-center gap-1.5 rounded border border-foundations-subtle bg-foundations-subtelst-02 p-1 pr-1.5">
      <span className="flex h-6 w-6 items-center justify-center rounded bg-foundations-bolder text-xs font-medium uppercase text-foundations-inverse">
        {name.slice(0, 2)}
      </span>

      <span className="text-sm font-medium text-foundations-bold">{name}</span>

      {!!onDeleteAccount && (
        <button
          type="button"
          onClick={() => onDeleteAccount(id)}
          aria-label="Delete account"
        >
          <XIcon
            className="h-5 w-5 text-foundations-subtler"
            aria-hidden="true"
          />
        </button>
      )}
    </div>
  );
};
